import { RoomBackdrop } from '../components/RoomBackdrop';
import { ABOUT_BOARDS, ABOUT_DARRYL, ABOUT_FIRM } from '../data/about';
import './AboutPage.css';

function boardLabel(board) {
  if (board.id === 'acla') return 'ACLA';
  return board.name;
}

function BoardTrack({ ariaHidden = false }) {
  const items = [...ABOUT_BOARDS, ...ABOUT_BOARDS];
  return (
    <div className="about-boards__track" aria-hidden={ariaHidden || undefined}>
      {items.map((board, i) => (
        <span
          key={`${ariaHidden ? 'b' : 'a'}-${board.id}-${i}`}
          className="about-boards__item"
        >
          {i > 0 ? <span className="about-boards__dot" aria-hidden /> : null}
          {boardLabel(board)}
        </span>
      ))}
      <span className="about-boards__dot about-boards__dot--sep" aria-hidden />
    </div>
  );
}

export function AboutPage() {
  return (
    <>
      <RoomBackdrop room="about" dim={0} fit="contain" />
      <main className="about-page">
        <section className="about-screen about-screen--hero" aria-label="The practice">
          <div className="about-hero">
            <div className="about-hero__copy">
              <h1 className="about-hero__headline">{ABOUT_FIRM.headline}</h1>
              <p className="about-hero__founding">{ABOUT_FIRM.founding}</p>
              <div className="about-stats" aria-label="Practice highlights">
                {ABOUT_FIRM.stats.map((stat) => (
                  <div key={stat.label} className="about-stat">
                    <span className="about-stat__value">{stat.value}</span>
                    <span className="about-stat__label">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <article className="about-principal">
              <div className="about-principal__body">
                <p className="about-principal__role">{ABOUT_DARRYL.role}</p>
                <h2 className="about-principal__name">{ABOUT_DARRYL.name}</h2>
                <p className="about-principal__claim">{ABOUT_DARRYL.claim}</p>
                <p className="about-principal__blurb">{ABOUT_DARRYL.blurb}</p>
              </div>
              <div className="about-principal__photo-wrap">
                <img
                  className="about-principal__photo"
                  src={ABOUT_DARRYL.photo}
                  alt={ABOUT_DARRYL.name}
                  width={480}
                  height={600}
                />
              </div>
            </article>
          </div>

          <div className="about-boards" aria-label="Board and advisory service">
            <div className="about-boards__viewport">
              <div className="about-boards__marquee">
                <BoardTrack />
                <BoardTrack ariaHidden />
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
